import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Msg, Toast } from 'react-weui';
import Http from 'services/http2';
import User from 'services/user2';
import ReactEcharts from 'echarts-for-react';
import TopNav from 'components/topNav';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';

import PropTypes from 'prop-types';
import * as MobileActions from '../../actions';
import { withStyles } from '@material-ui/core/styles';
import { formatDate } from 'lib/formatter.ts';
import StatisticsFns from 'functions/statistics';

/*
/mp/statistics/purchase/monthlyReport/:companyCode/:id
https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf3cf604fbe16e419&redirect_uri=http%3A%2F%2Fdev.xiekeyun.com%2Fmp%2Fstatistics%2Fpurchase%2FmonthlyReport%2F80777837%2F807778370J15Y64zVuW8C2lU2SK8234J&response_type=code&scope=snsapi_base&state=123#wechat_redirect
*/

const styles = theme => ({
  block: {
    position: 'relative',
    backgroundColor: '#fff',
    marginBottom: 20,
    padding: 16,
  },
  title: {
    color: '#53AAF4',
    paddingBottom: 10,
    fontSize: 14,
  },
  content: {
    overflow: 'hidden',
    color: '#666666',
    fontSize: '.9em',
    '& b': {
      color: '#101010',
    },
    '& span+span': {
      marginLeft: 6,
    },
  },
  column: {
    float: 'left',
    width: '50%',
    fontSize: '.9em',
  },
  card: {
    margin: '10px 5px',
  },
});

class StatisticsManagerialReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inited: false,
      error: null,
      showLoading: false,
      showError: false,
      detail: {},
      chartOpt1: {},
      chartOpt2: {},
      chartOpt3: {},
    };
    const { match } = props;
    this.companyCode = match.params.companyCode;
    this.id = match.params.id;
    this.errorMsg = '';
  }

  init() {
    User.init(this.companyCode).then(response => {
      if (response.success) {
        this.search();
        this.setState({ inited: true });
      } else {
        this.setState({
          error: {
            type: 'warn',
            title: response.errorMsg,
          },
        });
      }
    });
  }

  componentDidMount() {
    this.init();
  }

  errorFn(errorMsg) {
    this.errorMsg = errorMsg;
    this.setState({ showLoading: false });
    this.setState({ showError: true });
    this.errorTimer = setTimeout(() => {
      this.setState({ showError: false });
    }, 3000);
  }

  search() {
    let postbody = {
      companyCode: this.companyCode,
      reportXkUniqueCode: this.id,
      apiPath: '/statistical/monthlyReport/detail',
    };
    this.setState({ showLoading: true });
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let data = { ...response.data };
        data.onlineVendorRate = (
          (data.onlineVendorCount / data.vendorCount) *
          100
        ).toFixed(1);
        data.orderReplyRateShow = ((data.orderReplyRate || 0) * 100).toFixed(1);
        data.onlineDeliveryRateShow = (
          (data.onlineDeliveryRate || 0) * 100
        ).toFixed(1);
        data.deliveryReceiptRateShow = (
          (data.deliveryReceiptRate || 0) * 100
        ).toFixed(1);
        data.onlineStatementRateShow = (
          (data.onlineStatementRate || 0) * 100
        ).toFixed(1);
        this.setState({ detail: data });
        this.renderCharts(data);
      } else {
        this.errorFn(response.errorMsg);
      }
      this.setState({ showLoading: false });
    });
  }

  //渲染图表
  renderCharts(data) {
    this.setState({ chartOpt1: StatisticsFns.genPieBar2Opt(data, 1) });
    this.setState({ chartOpt2: StatisticsFns.genPieBar2Opt(data, 2) });
    this.setState({
      chartOpt3: StatisticsFns.genBar2Opt(data.assessmentScoreList),
    });
  }

  render() {
    const { classes } = this.props;
    if (this.state.error !== null) {
      return <Msg {...this.state.error} />;
    }
    let detail = this.state.detail;
    return (
      <div>
        <TopNav inited={this.state.inited} />
        <div className={classes.block}>
          <div className={classes.title}>
            <label>报告日期:</label>
            <span className="ml5">
              {detail.reportDate ? formatDate(detail.reportDate) : '--'}
            </span>
          </div>
          <ul className={classes.content}>
            <li className={classes.column}>
              <b>{detail.onlineVendorCount}</b>
              <span>家</span>
            </li>
            <li className={classes.column}>
              <span>供应商总数</span>
              <span>{detail.vendorCount}</span>
            </li>
            <li className={classes.column}>上线供应商</li>
            <li className={classes.column}>
              <span>已上线比例</span>
              <span className="red">{detail.onlineVendorRate}%</span>
            </li>
          </ul>
        </div>

        <div className={classes.block}>
          <div className={classes.title}>
            <label>平台应用</label>
          </div>
          <ul className={classes.content}>
            <li className={classes.column}>
              <span>订单答交率</span>
              <span>{detail.orderReplyRateShow}%</span>
            </li>
            <li className={classes.column}>
              <span>在线送货率</span>
              <span>{detail.onlineDeliveryRateShow}%</span>
            </li>
            <li className={classes.column}>
              <span>送货签收率</span>
              <span className="red">{detail.deliveryReceiptRateShow}%</span>
            </li>
            <li className={classes.column}>
              <span>在线对账率</span>
              <span>{detail.onlineStatementRateShow}%</span>
            </li>
          </ul>
        </div>

        <Card className={classes.card}>
          <CardHeader title="采购达成分析（按物料）" />
          <Divider />
          <CardContent style={{ padding: '10px' }}>
            <ReactEcharts
              option={this.state.chartOpt1}
              notMerge={true}
              lazyUpdate={true}
            />
          </CardContent>
        </Card>

        <Card className={classes.card}>
          <CardHeader title="采购价格分析" />
          <Divider />
          <CardContent style={{ padding: '10px' }}>
            <ReactEcharts
              option={this.state.chartOpt2}
              notMerge={true}
              lazyUpdate={true}
            />
          </CardContent>
        </Card>

        <Card className={classes.card}>
          <CardHeader title="供应商绩效分析" />
          <Divider />
          <CardContent style={{ padding: '10px' }}>
            <ReactEcharts
              option={this.state.chartOpt3}
              notMerge={true}
              lazyUpdate={true}
            />
          </CardContent>
        </Card>

        <Toast icon="warn" show={this.state.showError}>
          {this.errorMsg}
        </Toast>
        <Toast icon="loading" show={this.state.showLoading}>
          Loading...
        </Toast>
      </div>
    );
  }
}

StatisticsManagerialReport.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
  return {
    data: state.login,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(StatisticsManagerialReport));
